/**
 * Call sheet links.
 *
 * The crew-facing call sheet is a separate, deliberately lightweight app from
 * the client portal — no login, just a link, meant to be pasted straight into
 * the shoot's WhatsApp group.
 *
 * Two tiers: a Crew link with everything (schedule, contacts, shots, kit,
 * plus the internal instructions and files), and a lighter Client link
 * (schedule, contacts, location — no shots, no kit, no internal notes).
 * Crew and staff used to be two separate tiers with no client-facing link at
 * all; Tom asked on 9 Sep 2026 to collapse them into one full-access Crew
 * link and add a real Client link in their place.
 *
 * The app behind these links was called "Shoot Day" until 13 Sep 2026, when
 * Tom asked for one name for one thing: "lets only call it a call sheet".
 * The URL is unchanged, so every link already in a WhatsApp group still
 * works — only the wording moved.
 *
 * THE DOMAIN, moved 22 Sep 2026. It was the raw Magic Patterns preview
 * address — project-flourishing-snow-552.magicpatterns.app — which is what a
 * client saw in their WhatsApp preview, naming a tool Portal had no reason to
 * put in front of them. It now runs on callsheet.portalproductions.me, a
 * CNAME to magicpatterns.dev set up alongside the existing clients.
 * portalproductions.me record for the main portal.
 *
 * Magic Patterns keeps serving the old .magicpatterns.app address as well, so
 * every link already sitting in a WhatsApp group still opens. Nothing had to
 * be reissued, and no token changed.
 */
export const CALL_SHEET_BASE_URL = 'https://callsheet.portalproductions.me'

function callSheetLink(token: string): string {
  if (!token) return ''
  return `${CALL_SHEET_BASE_URL}/?token=${encodeURIComponent(token)}`
}

/** Today, Schedule, Contacts, Shots, Kit, plus the internal notes and files. */
export function shootDayCrewLink(token: string): string {
  return callSheetLink(token)
}

/** Today, Schedule, Contacts only — no Shots, no Kit, no internal notes. */
export function shootDayClientLink(token: string): string {
  return callSheetLink(token)
}
